import { rem } from 'polished'
import styled from 'styled-components'

import LoadingBox from 'components/Common/Loading/LoadingBox'

const CardLoader = styled(LoadingBox)`
  padding: ${rem(16)};
  border-radius: ${(props) => props.theme.borderRadius.M};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  min-height: ${rem(120)};
  width: 100%;
`

function FlightItemCardSkeleton() {
  return <CardLoader />
}

export default FlightItemCardSkeleton
